import axios from "axios";

// API do agente da AZUL. Arquivo proprio (nao mexe no nexiaApi.js da CVC); mesma
// origem/cookie de sessao e mesmo tratamento de 401 do restante do dashboard.
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL ?? "http://localhost:3500",
  timeout: 15000,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      window.dispatchEvent(new CustomEvent("nexia:unauthenticated"));
    }
    return Promise.reject(err);
  }
);

/** Pedido de execucao desta base+etapa esperando a vez? -> { naFila, posicao, pendentes } (GET /azul/fila). */
export async function getAzulFila(base, etapa = "completa") {
  const { data } = await api.get("/azul/fila", { params: { base, etapa } });
  return data;
}

/** Ambiente (hml|prod) em que a AZUL esta: interruptor proprio, independente do da CVC (GET /azul/env). */
export async function getAzulEnv() {
  const { data } = await api.get("/azul/env");
  return data.ambiente === "prod" ? "prod" : "hml";
}

function toISO(date) {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Mensagem de erro legivel vinda da API (ou um texto padrao). */
export function azulErro(err, padrao = "Falha ao falar com o servidor") {
  return (
    (err && err.response && err.response.data && err.response.data.error) ||
    padrao
  );
}

/** As 7 bases [{slug,label}]. */
export async function getAzulBases() {
  const { data } = await api.get("/azul/bases");
  return data;
}

/** Cartoes de Resumo do periodo, por base. */
export async function getAzulIndicators(range, base) {
  const { data } = await api.get("/azul/indicators", {
    params: {
      start: toISO(range.start),
      end: toISO(range.end),
      ...(base ? { base } : {}),
    },
  });
  return data;
}

/** Aba Importacao: numeros por reserva enviada, execucoes e listas (erro / sem pendencia / com pendencia). */
export async function getAzulImportDetail(range, base) {
  const { data } = await api.get("/azul/import-detail", {
    params: {
      start: toISO(range.start),
      end: toISO(range.end),
      ...(base ? { base } : {}),
    },
  });
  return data;
}

/** Execucoes do periodo (formato da lista da CVC: date/start/end/duration/status/qty). */
export async function getAzulExecutions(range, base, etapa) {
  const { data } = await api.get("/azul/executions", {
    params: {
      start: toISO(range.start),
      end: toISO(range.end),
      limit: 100,
      ...(base ? { base } : {}),
      // "completa" (importacao) | "respostas" (so ler e-mails e corrigir): cada painel lista so as suas
      ...(etapa ? { etapa } : {}),
    },
  });
  return data;
}

/** Aba Detalhamento (mesmo modelo da CVC): { totals, items }. */
export async function getAzulPendenciesDetail(range, base) {
  const { data } = await api.get("/azul/pendencies-detail", {
    params: {
      start: toISO(range.start),
      end: toISO(range.end),
      ...(base ? { base } : {}),
    },
  });
  return data;
}

/** Execucao + timeline + planilhas. */
export async function getAzulExecution(id) {
  const { data } = await api.get(`/azul/executions/${id}`);
  return data;
}

/**
 * Botao "Executar agora": coloca na fila. Periodo em DD/MM/AAAA (max. 30 dias,
 * validado no servidor). aceitarAntigo=true = "importar mesmo assim" a planilha
 * mais recente quando a de hoje nao chegou.
 */
export async function runAzul(
  base,
  { dataInicial, dataFinal, aceitarAntigo = false, etapa = "completa" }
) {
  const { data } = await api.post("/azul/run", {
    base,
    etapa,
    dataInicial,
    dataFinal,
    aceitarAntigo,
  });
  return data;
}

/**
 * Botao "Ler respostas e corrigir": execucao SO das respostas da Azul por e-mail (le os encerramentos dos chamados do agente e
 * corrige no Phoenix). Nao importa planilha, nao abre chamado e nao tem periodo.
 */
export async function runAzulRespostas(base) {
  const { data } = await api.post("/azul/run", { base, etapa: "respostas" });
  return data;
}

/** Respostas da Azul por e-mail aos chamados do agente: { itens, contagens }. grupo: avisos|aplicadas|equipe|vistos|todas. */
export async function getAzulRespostas(base, { grupo = "todas", q = "", limit = 100 } = {}) {
  const { data } = await api.get("/azul/respostas", {
    params: { base, grupo, limit, ...(q ? { q } : {}) },
  });
  return data;
}

/** Chamados abertos pelo agente que ainda nao tiveram resposta da Azul (com os dias de espera). */
export async function getAzulRespostasAguardando(base) {
  const { data } = await api.get("/azul/respostas/aguardando", { params: { base } });
  return data;
}

/** Marca (ou desmarca) um aviso como visto pela equipe. */
export async function marcarAzulRespostaVista(id, visto = true) {
  const { data } = await api.post(`/azul/respostas/${id}/visto`, { visto });
  return data;
}
